module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train_color_green-405e91f5358fe209c6e5dd0bd80434e2.svg";